import * as w from "react";
import { useLayoutEffect as gn, useState as vn } from "react";
import { e as $e, u as Ue, P as Re, f as Ve, c as wn } from "./index-BwqhVa-H.js";
import { jsx as j } from "react/jsx-runtime";
import * as yn from "react-dom";
var ke = 0;
function Bo() {
  w.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? lt()), document.body.insertAdjacentElement("beforeend", e[1] ?? lt()), ke++, () => {
      ke === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), ke--;
    };
  }, []);
}
function lt() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Ne = "focusScope.autoFocusOnMount", Fe = "focusScope.autoFocusOnUnmount", ut = { bubbles: !1, cancelable: !0 }, bn = "FocusScope", xn = w.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...s
  } = e, [c, f] = w.useState(null), u = $e(o), d = $e(i), l = w.useRef(null), m = Ue(t, (a) => f(a)), h = w.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  w.useEffect(() => {
    if (r) {
      let a = function(b) {
        if (h.paused || !c) return;
        const x = b.target;
        c.contains(x) ? l.current = x : Z(l.current, { select: !0 });
      }, p = function(b) {
        if (h.paused || !c) return;
        const x = b.relatedTarget;
        x !== null && (c.contains(x) || Z(l.current, { select: !0 }));
      }, g = function(b) {
        if (document.activeElement === document.body)
          for (const S of b)
            S.removedNodes.length > 0 && Z(c);
      };
      document.addEventListener("focusin", a), document.addEventListener("focusout", p);
      const y = new MutationObserver(g);
      return c && y.observe(c, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", a), document.removeEventListener("focusout", p), y.disconnect();
      };
    }
  }, [r, c, h.paused]), w.useEffect(() => {
    if (c) {
      dt.add(h);
      const a = document.activeElement;
      if (!c.contains(a)) {
        const g = new CustomEvent(Ne, ut);
        c.addEventListener(Ne, u), c.dispatchEvent(g), g.defaultPrevented || (Sn(On(Mt(c)), { select: !0 }), document.activeElement === a && Z(c));
      }
      return () => {
        c.removeEventListener(Ne, u), setTimeout(() => {
          const g = new CustomEvent(Fe, ut);
          c.addEventListener(Fe, d), c.dispatchEvent(g), g.defaultPrevented || Z(a ?? document.body, { select: !0 }), c.removeEventListener(Fe, d), dt.remove(h);
        }, 0);
      };
    }
  }, [c, u, d, h]);
  const v = w.useCallback(
    (a) => {
      if (!n && !r || h.paused) return;
      const p = a.key === "Tab" && !a.altKey && !a.ctrlKey && !a.metaKey, g = document.activeElement;
      if (p && g) {
        const y = a.currentTarget, [b, x] = An(y);
        b && x ? !a.shiftKey && g === x ? (a.preventDefault(), n && Z(b, { select: !0 })) : a.shiftKey && g === b && (a.preventDefault(), n && Z(x, { select: !0 })) : g === y && a.preventDefault();
      }
    },
    [n, r, h.paused]
  );
  return /* @__PURE__ */ j(Re.div, { tabIndex: -1, ...s, ref: m, onKeyDown: v });
});
xn.displayName = bn;
function Sn(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Z(r, { select: t }), document.activeElement !== n) return;
}
function An(e) {
  const t = Mt(e), n = ft(t, e), r = ft(t.reverse(), e);
  return [n, r];
}
function Mt(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function ft(e, t) {
  for (const n of e)
    if (!En(n, { upTo: t })) return n;
}
function En(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Cn(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Z(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Cn(e) && t && e.select();
  }
}
var dt = Rn();
function Rn() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = ht(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = ht(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function ht(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function On(e) {
  return e.filter((t) => t.tagName !== "A");
}
const Pn = ["top", "right", "bottom", "left"], G = Math.min, B = Math.max, Se = Math.round, me = Math.floor, X = (e) => ({
  x: e,
  y: e
}), Tn = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Mn = {
  start: "end",
  end: "start"
};
function ze(e, t, n) {
  return B(e, G(t, n));
}
function K(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function q(e) {
  return e.split("-")[0];
}
function se(e) {
  return e.split("-")[1];
}
function Ke(e) {
  return e === "x" ? "y" : "x";
}
function qe(e) {
  return e === "y" ? "height" : "width";
}
const Ln = /* @__PURE__ */ new Set(["top", "bottom"]);
function z(e) {
  return Ln.has(q(e)) ? "y" : "x";
}
function Ze(e) {
  return Ke(z(e));
}
function kn(e, t, n) {
  n === void 0 && (n = !1);
  const r = se(e), o = Ze(e), i = qe(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = Ae(s)), [s, Ae(s)];
}
function Nn(e) {
  const t = Ae(e);
  return [je(e), t, je(t)];
}
function je(e) {
  return e.replace(/start|end/g, (t) => Mn[t]);
}
const mt = ["left", "right"], pt = ["right", "left"], Fn = ["top", "bottom"], Dn = ["bottom", "top"];
function Wn(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? pt : mt : t ? mt : pt;
    case "left":
    case "right":
      return t ? Fn : Dn;
    default:
      return [];
  }
}
function Bn(e, t, n, r) {
  const o = se(e);
  let i = Wn(q(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(je)))), i;
}
function Ae(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Tn[t]);
}
function In(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Lt(e) {
  return typeof e != "number" ? In(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ee(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function gt(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = z(t), s = Ze(t), c = qe(s), f = q(t), u = i === "y", d = r.x + r.width / 2 - o.width / 2, l = r.y + r.height / 2 - o.height / 2, m = r[c] / 2 - o[c] / 2;
  let h;
  switch (f) {
    case "top":
      h = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: l
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: l
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (se(t)) {
    case "start":
      h[s] -= m * (n && u ? -1 : 1);
      break;
    case "end":
      h[s] += m * (n && u ? -1 : 1);
      break;
  }
  return h;
}
const _n = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, c = i.filter(Boolean), f = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let u = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: d,
    y: l
  } = gt(u, r, f), m = r, h = {}, v = 0;
  for (let a = 0; a < c.length; a++) {
    const {
      name: p,
      fn: g
    } = c[a], {
      x: y,
      y: b,
      data: x,
      reset: S
    } = await g({
      x: d,
      y: l,
      initialPlacement: r,
      placement: m,
      strategy: o,
      middlewareData: h,
      rects: u,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = y ?? d, l = b ?? l, h = {
      ...h,
      [p]: {
        ...h[p],
        ...x
      }
    }, S && v <= 50 && (v++, typeof S == "object" && (S.placement && (m = S.placement), S.rects && (u = S.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : S.rects), {
      x: d,
      y: l
    } = gt(u, m, f)), a = -1);
  }
  return {
    x: d,
    y: l,
    placement: m,
    strategy: o,
    middlewareData: h
  };
};
async function le(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: c,
    strategy: f
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: l = "floating",
    altBoundary: m = !1,
    padding: h = 0
  } = K(t, e), v = Lt(h), p = c[m ? l === "floating" ? "reference" : "floating" : l], g = Ee(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(p))) == null || n ? p : p.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(c.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: f
  })), y = l === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, b = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c.floating)), x = await (i.isElement == null ? void 0 : i.isElement(b)) ? await (i.getScale == null ? void 0 : i.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = Ee(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: y,
    offsetParent: b,
    strategy: f
  }) : y);
  return {
    top: (g.top - S.top + v.top) / x.y,
    bottom: (S.bottom - g.bottom + v.bottom) / x.y,
    left: (g.left - S.left + v.left) / x.x,
    right: (S.right - g.right + v.right) / x.x
  };
}
const Hn = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: c,
      middlewareData: f
    } = t, {
      element: u,
      padding: d = 0
    } = K(e, t) || {};
    if (u == null)
      return {};
    const l = Lt(d), m = {
      x: n,
      y: r
    }, h = Ze(o), v = qe(h), a = await s.getDimensions(u), p = h === "y", g = p ? "top" : "left", y = p ? "bottom" : "right", b = p ? "clientHeight" : "clientWidth", x = i.reference[v] + i.reference[h] - m[h] - i.floating[v], S = m[h] - i.reference[h], A = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(u));
    let E = A ? A[b] : 0;
    (!E || !await (s.isElement == null ? void 0 : s.isElement(A))) && (E = c.floating[b] || i.floating[v]);
    const O = x / 2 - S / 2, N = E / 2 - a[v] / 2 - 1, P = G(l[g], N), T = G(l[y], N), F = P, M = E - a[v] - T, R = E / 2 - a[v] / 2 + O, W = ze(F, R, M), L = !f.arrow && se(o) != null && R !== W && i.reference[v] / 2 - (R < F ? P : T) - a[v] / 2 < 0, k = L ? R < F ? R - F : R - M : 0;
    return {
      [h]: m[h] + k,
      data: {
        [h]: W,
        centerOffset: R - W - k,
        ...L && {
          alignmentOffset: k
        }
      },
      reset: L
    };
  }
}), $n = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: c,
        platform: f,
        elements: u
      } = t, {
        mainAxis: d = !0,
        crossAxis: l = !0,
        fallbackPlacements: m,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: a = !0,
        ...p
      } = K(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const g = q(o), y = z(c), b = q(c) === c, x = await (f.isRTL == null ? void 0 : f.isRTL(u.floating)), S = m || (b || !a ? [Ae(c)] : Nn(c)), A = v !== "none";
      !m && A && S.push(...Bn(c, a, v, x));
      const E = [c, ...S], O = await le(t, p), N = [];
      let P = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (d && N.push(O[g]), l) {
        const R = kn(o, s, x);
        N.push(O[R[0]], O[R[1]]);
      }
      if (P = [...P, {
        placement: o,
        overflows: N
      }], !N.every((R) => R <= 0)) {
        var T, F;
        const R = (((T = i.flip) == null ? void 0 : T.index) || 0) + 1, W = E[R];
        if (W && (!(l === "alignment" ? y !== z(W) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        P.every((C) => z(C.placement) === y ? C.overflows[0] > 0 : !0)))
          return {
            data: {
              index: R,
              overflows: P
            },
            reset: {
              placement: W
            }
          };
        let L = (F = P.filter((k) => k.overflows[0] <= 0).sort((k, C) => k.overflows[1] - C.overflows[1])[0]) == null ? void 0 : F.placement;
        if (!L)
          switch (h) {
            case "bestFit": {
              var M;
              const k = (M = P.filter((C) => {
                if (A) {
                  const D = z(C.placement);
                  return D === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  D === "y";
                }
                return !0;
              }).map((C) => [C.placement, C.overflows.filter((D) => D > 0).reduce((D, $) => D + $, 0)]).sort((C, D) => C[1] - D[1])[0]) == null ? void 0 : M[0];
              k && (L = k);
              break;
            }
            case "initialPlacement":
              L = c;
              break;
          }
        if (o !== L)
          return {
            reset: {
              placement: L
            }
          };
      }
      return {};
    }
  };
};
function vt(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function wt(e) {
  return Pn.some((t) => e[t] >= 0);
}
const Vn = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = K(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await le(t, {
            ...o,
            elementContext: "reference"
          }), s = vt(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: wt(s)
            }
          };
        }
        case "escaped": {
          const i = await le(t, {
            ...o,
            altBoundary: !0
          }), s = vt(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: wt(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, kt = /* @__PURE__ */ new Set(["left", "top"]);
async function zn(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = q(n), c = se(n), f = z(n) === "y", u = kt.has(s) ? -1 : 1, d = i && f ? -1 : 1, l = K(t, e);
  let {
    mainAxis: m,
    crossAxis: h,
    alignmentAxis: v
  } = typeof l == "number" ? {
    mainAxis: l,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: l.mainAxis || 0,
    crossAxis: l.crossAxis || 0,
    alignmentAxis: l.alignmentAxis
  };
  return c && typeof v == "number" && (h = c === "end" ? v * -1 : v), f ? {
    x: h * d,
    y: m * u
  } : {
    x: m * u,
    y: h * d
  };
}
const jn = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: c
      } = t, f = await zn(t, e);
      return s === ((n = c.offset) == null ? void 0 : n.placement) && (r = c.arrow) != null && r.alignmentOffset ? {} : {
        x: o + f.x,
        y: i + f.y,
        data: {
          ...f,
          placement: s
        }
      };
    }
  };
}, Xn = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: c = {
          fn: (p) => {
            let {
              x: g,
              y
            } = p;
            return {
              x: g,
              y
            };
          }
        },
        ...f
      } = K(e, t), u = {
        x: n,
        y: r
      }, d = await le(t, f), l = z(q(o)), m = Ke(l);
      let h = u[m], v = u[l];
      if (i) {
        const p = m === "y" ? "top" : "left", g = m === "y" ? "bottom" : "right", y = h + d[p], b = h - d[g];
        h = ze(y, h, b);
      }
      if (s) {
        const p = l === "y" ? "top" : "left", g = l === "y" ? "bottom" : "right", y = v + d[p], b = v - d[g];
        v = ze(y, v, b);
      }
      const a = c.fn({
        ...t,
        [m]: h,
        [l]: v
      });
      return {
        ...a,
        data: {
          x: a.x - n,
          y: a.y - r,
          enabled: {
            [m]: i,
            [l]: s
          }
        }
      };
    }
  };
}, Yn = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: s
      } = t, {
        offset: c = 0,
        mainAxis: f = !0,
        crossAxis: u = !0
      } = K(e, t), d = {
        x: n,
        y: r
      }, l = z(o), m = Ke(l);
      let h = d[m], v = d[l];
      const a = K(c, t), p = typeof a == "number" ? {
        mainAxis: a,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...a
      };
      if (f) {
        const b = m === "y" ? "height" : "width", x = i.reference[m] - i.floating[b] + p.mainAxis, S = i.reference[m] + i.reference[b] - p.mainAxis;
        h < x ? h = x : h > S && (h = S);
      }
      if (u) {
        var g, y;
        const b = m === "y" ? "width" : "height", x = kt.has(q(o)), S = i.reference[l] - i.floating[b] + (x && ((g = s.offset) == null ? void 0 : g[l]) || 0) + (x ? 0 : p.crossAxis), A = i.reference[l] + i.reference[b] + (x ? 0 : ((y = s.offset) == null ? void 0 : y[l]) || 0) - (x ? p.crossAxis : 0);
        v < S ? v = S : v > A && (v = A);
      }
      return {
        [m]: h,
        [l]: v
      };
    }
  };
}, Un = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: s,
        elements: c
      } = t, {
        apply: f = () => {
        },
        ...u
      } = K(e, t), d = await le(t, u), l = q(o), m = se(o), h = z(o) === "y", {
        width: v,
        height: a
      } = i.floating;
      let p, g;
      l === "top" || l === "bottom" ? (p = l, g = m === (await (s.isRTL == null ? void 0 : s.isRTL(c.floating)) ? "start" : "end") ? "left" : "right") : (g = l, p = m === "end" ? "top" : "bottom");
      const y = a - d.top - d.bottom, b = v - d.left - d.right, x = G(a - d[p], y), S = G(v - d[g], b), A = !t.middlewareData.shift;
      let E = x, O = S;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (O = b), (r = t.middlewareData.shift) != null && r.enabled.y && (E = y), A && !m) {
        const P = B(d.left, 0), T = B(d.right, 0), F = B(d.top, 0), M = B(d.bottom, 0);
        h ? O = v - 2 * (P !== 0 || T !== 0 ? P + T : B(d.left, d.right)) : E = a - 2 * (F !== 0 || M !== 0 ? F + M : B(d.top, d.bottom));
      }
      await f({
        ...t,
        availableWidth: O,
        availableHeight: E
      });
      const N = await s.getDimensions(c.floating);
      return v !== N.width || a !== N.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Oe() {
  return typeof window < "u";
}
function ce(e) {
  return Nt(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function I(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function U(e) {
  var t;
  return (t = (Nt(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Nt(e) {
  return Oe() ? e instanceof Node || e instanceof I(e).Node : !1;
}
function _(e) {
  return Oe() ? e instanceof Element || e instanceof I(e).Element : !1;
}
function Y(e) {
  return Oe() ? e instanceof HTMLElement || e instanceof I(e).HTMLElement : !1;
}
function yt(e) {
  return !Oe() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof I(e).ShadowRoot;
}
const Kn = /* @__PURE__ */ new Set(["inline", "contents"]);
function fe(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = H(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !Kn.has(o);
}
const qn = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Zn(e) {
  return qn.has(ce(e));
}
const Gn = [":popover-open", ":modal"];
function Pe(e) {
  return Gn.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const Qn = ["transform", "translate", "scale", "rotate", "perspective"], Jn = ["transform", "translate", "scale", "rotate", "perspective", "filter"], er = ["paint", "layout", "strict", "content"];
function Ge(e) {
  const t = Qe(), n = _(e) ? H(e) : e;
  return Qn.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || Jn.some((r) => (n.willChange || "").includes(r)) || er.some((r) => (n.contain || "").includes(r));
}
function tr(e) {
  let t = Q(e);
  for (; Y(t) && !ie(t); ) {
    if (Ge(t))
      return t;
    if (Pe(t))
      return null;
    t = Q(t);
  }
  return null;
}
function Qe() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const nr = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function ie(e) {
  return nr.has(ce(e));
}
function H(e) {
  return I(e).getComputedStyle(e);
}
function Te(e) {
  return _(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Q(e) {
  if (ce(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    yt(e) && e.host || // Fallback.
    U(e)
  );
  return yt(t) ? t.host : t;
}
function Ft(e) {
  const t = Q(e);
  return ie(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Y(t) && fe(t) ? t : Ft(t);
}
function ue(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Ft(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = I(o);
  if (i) {
    const c = Xe(s);
    return t.concat(s, s.visualViewport || [], fe(o) ? o : [], c && n ? ue(c) : []);
  }
  return t.concat(o, ue(o, [], n));
}
function Xe(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Dt(e) {
  const t = H(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Y(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, c = Se(n) !== i || Se(r) !== s;
  return c && (n = i, r = s), {
    width: n,
    height: r,
    $: c
  };
}
function Je(e) {
  return _(e) ? e : e.contextElement;
}
function re(e) {
  const t = Je(e);
  if (!Y(t))
    return X(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = Dt(t);
  let s = (i ? Se(n.width) : n.width) / r, c = (i ? Se(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
const rr = /* @__PURE__ */ X(0);
function Wt(e) {
  const t = I(e);
  return !Qe() || !t.visualViewport ? rr : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function or(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== I(e) ? !1 : t;
}
function J(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Je(e);
  let s = X(1);
  t && (r ? _(r) && (s = re(r)) : s = re(e));
  const c = or(i, n, r) ? Wt(i) : X(0);
  let f = (o.left + c.x) / s.x, u = (o.top + c.y) / s.y, d = o.width / s.x, l = o.height / s.y;
  if (i) {
    const m = I(i), h = r && _(r) ? I(r) : r;
    let v = m, a = Xe(v);
    for (; a && r && h !== v; ) {
      const p = re(a), g = a.getBoundingClientRect(), y = H(a), b = g.left + (a.clientLeft + parseFloat(y.paddingLeft)) * p.x, x = g.top + (a.clientTop + parseFloat(y.paddingTop)) * p.y;
      f *= p.x, u *= p.y, d *= p.x, l *= p.y, f += b, u += x, v = I(a), a = Xe(v);
    }
  }
  return Ee({
    width: d,
    height: l,
    x: f,
    y: u
  });
}
function Me(e, t) {
  const n = Te(e).scrollLeft;
  return t ? t.left + n : J(U(e)).left + n;
}
function Bt(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - Me(e, n), o = n.top + t.scrollTop;
  return {
    x: r,
    y: o
  };
}
function ir(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", s = U(r), c = t ? Pe(t.floating) : !1;
  if (r === s || c && i)
    return n;
  let f = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = X(1);
  const d = X(0), l = Y(r);
  if ((l || !l && !i) && ((ce(r) !== "body" || fe(s)) && (f = Te(r)), Y(r))) {
    const h = J(r);
    u = re(r), d.x = h.x + r.clientLeft, d.y = h.y + r.clientTop;
  }
  const m = s && !l && !i ? Bt(s, f) : X(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - f.scrollLeft * u.x + d.x + m.x,
    y: n.y * u.y - f.scrollTop * u.y + d.y + m.y
  };
}
function sr(e) {
  return Array.from(e.getClientRects());
}
function cr(e) {
  const t = U(e), n = Te(e), r = e.ownerDocument.body, o = B(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = B(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Me(e);
  const c = -n.scrollTop;
  return H(r).direction === "rtl" && (s += B(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: c
  };
}
const bt = 25;
function ar(e, t) {
  const n = I(e), r = U(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, c = 0, f = 0;
  if (o) {
    i = o.width, s = o.height;
    const d = Qe();
    (!d || d && t === "fixed") && (c = o.offsetLeft, f = o.offsetTop);
  }
  const u = Me(r);
  if (u <= 0) {
    const d = r.ownerDocument, l = d.body, m = getComputedStyle(l), h = d.compatMode === "CSS1Compat" && parseFloat(m.marginLeft) + parseFloat(m.marginRight) || 0, v = Math.abs(r.clientWidth - l.clientWidth - h);
    v <= bt && (i -= v);
  } else u <= bt && (i += u);
  return {
    width: i,
    height: s,
    x: c,
    y: f
  };
}
const lr = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function ur(e, t) {
  const n = J(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = Y(e) ? re(e) : X(1), s = e.clientWidth * i.x, c = e.clientHeight * i.y, f = o * i.x, u = r * i.y;
  return {
    width: s,
    height: c,
    x: f,
    y: u
  };
}
function xt(e, t, n) {
  let r;
  if (t === "viewport")
    r = ar(e, n);
  else if (t === "document")
    r = cr(U(e));
  else if (_(t))
    r = ur(t, n);
  else {
    const o = Wt(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return Ee(r);
}
function It(e, t) {
  const n = Q(e);
  return n === t || !_(n) || ie(n) ? !1 : H(n).position === "fixed" || It(n, t);
}
function fr(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = ue(e, [], !1).filter((c) => _(c) && ce(c) !== "body"), o = null;
  const i = H(e).position === "fixed";
  let s = i ? Q(e) : e;
  for (; _(s) && !ie(s); ) {
    const c = H(s), f = Ge(s);
    !f && c.position === "fixed" && (o = null), (i ? !f && !o : !f && c.position === "static" && !!o && lr.has(o.position) || fe(s) && !f && It(e, s)) ? r = r.filter((d) => d !== s) : o = c, s = Q(s);
  }
  return t.set(e, r), r;
}
function dr(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? Pe(t) ? [] : fr(t, this._c) : [].concat(n), r], c = s[0], f = s.reduce((u, d) => {
    const l = xt(t, d, o);
    return u.top = B(l.top, u.top), u.right = G(l.right, u.right), u.bottom = G(l.bottom, u.bottom), u.left = B(l.left, u.left), u;
  }, xt(t, c, o));
  return {
    width: f.right - f.left,
    height: f.bottom - f.top,
    x: f.left,
    y: f.top
  };
}
function hr(e) {
  const {
    width: t,
    height: n
  } = Dt(e);
  return {
    width: t,
    height: n
  };
}
function mr(e, t, n) {
  const r = Y(t), o = U(t), i = n === "fixed", s = J(e, !0, i, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const f = X(0);
  function u() {
    f.x = Me(o);
  }
  if (r || !r && !i)
    if ((ce(t) !== "body" || fe(o)) && (c = Te(t)), r) {
      const h = J(t, !0, i, t);
      f.x = h.x + t.clientLeft, f.y = h.y + t.clientTop;
    } else o && u();
  i && !r && o && u();
  const d = o && !r && !i ? Bt(o, c) : X(0), l = s.left + c.scrollLeft - f.x - d.x, m = s.top + c.scrollTop - f.y - d.y;
  return {
    x: l,
    y: m,
    width: s.width,
    height: s.height
  };
}
function De(e) {
  return H(e).position === "static";
}
function St(e, t) {
  if (!Y(e) || H(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return U(e) === n && (n = n.ownerDocument.body), n;
}
function _t(e, t) {
  const n = I(e);
  if (Pe(e))
    return n;
  if (!Y(e)) {
    let o = Q(e);
    for (; o && !ie(o); ) {
      if (_(o) && !De(o))
        return o;
      o = Q(o);
    }
    return n;
  }
  let r = St(e, t);
  for (; r && Zn(r) && De(r); )
    r = St(r, t);
  return r && ie(r) && De(r) && !Ge(r) ? n : r || tr(e) || n;
}
const pr = async function(e) {
  const t = this.getOffsetParent || _t, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: mr(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function gr(e) {
  return H(e).direction === "rtl";
}
const vr = {
  convertOffsetParentRelativeRectToViewportRelativeRect: ir,
  getDocumentElement: U,
  getClippingRect: dr,
  getOffsetParent: _t,
  getElementRects: pr,
  getClientRects: sr,
  getDimensions: hr,
  getScale: re,
  isElement: _,
  isRTL: gr
};
function Ht(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function wr(e, t) {
  let n = null, r;
  const o = U(e);
  function i() {
    var c;
    clearTimeout(r), (c = n) == null || c.disconnect(), n = null;
  }
  function s(c, f) {
    c === void 0 && (c = !1), f === void 0 && (f = 1), i();
    const u = e.getBoundingClientRect(), {
      left: d,
      top: l,
      width: m,
      height: h
    } = u;
    if (c || t(), !m || !h)
      return;
    const v = me(l), a = me(o.clientWidth - (d + m)), p = me(o.clientHeight - (l + h)), g = me(d), b = {
      rootMargin: -v + "px " + -a + "px " + -p + "px " + -g + "px",
      threshold: B(0, G(1, f)) || 1
    };
    let x = !0;
    function S(A) {
      const E = A[0].intersectionRatio;
      if (E !== f) {
        if (!x)
          return s();
        E ? s(!1, E) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !Ht(u, e.getBoundingClientRect()) && s(), x = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...b,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, b);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function yr(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: f = !1
  } = r, u = Je(e), d = o || i ? [...u ? ue(u) : [], ...ue(t)] : [];
  d.forEach((g) => {
    o && g.addEventListener("scroll", n, {
      passive: !0
    }), i && g.addEventListener("resize", n);
  });
  const l = u && c ? wr(u, n) : null;
  let m = -1, h = null;
  s && (h = new ResizeObserver((g) => {
    let [y] = g;
    y && y.target === u && h && (h.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var b;
      (b = h) == null || b.observe(t);
    })), n();
  }), u && !f && h.observe(u), h.observe(t));
  let v, a = f ? J(e) : null;
  f && p();
  function p() {
    const g = J(e);
    a && !Ht(a, g) && n(), a = g, v = requestAnimationFrame(p);
  }
  return n(), () => {
    var g;
    d.forEach((y) => {
      o && y.removeEventListener("scroll", n), i && y.removeEventListener("resize", n);
    }), l == null || l(), (g = h) == null || g.disconnect(), h = null, f && cancelAnimationFrame(v);
  };
}
const br = jn, xr = Xn, Sr = $n, Ar = Un, Er = Vn, At = Hn, Cr = Yn, Rr = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: vr,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return _n(e, t, {
    ...o,
    platform: i
  });
};
var Or = typeof document < "u", Pr = function() {
}, ye = Or ? gn : Pr;
function Ce(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!Ce(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !Ce(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function $t(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Et(e, t) {
  const n = $t(e);
  return Math.round(t * n) / n;
}
function We(e) {
  const t = w.useRef(e);
  return ye(() => {
    t.current = e;
  }), t;
}
function Tr(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: c = !0,
    whileElementsMounted: f,
    open: u
  } = e, [d, l] = w.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, h] = w.useState(r);
  Ce(m, r) || h(r);
  const [v, a] = w.useState(null), [p, g] = w.useState(null), y = w.useCallback((C) => {
    C !== A.current && (A.current = C, a(C));
  }, []), b = w.useCallback((C) => {
    C !== E.current && (E.current = C, g(C));
  }, []), x = i || v, S = s || p, A = w.useRef(null), E = w.useRef(null), O = w.useRef(d), N = f != null, P = We(f), T = We(o), F = We(u), M = w.useCallback(() => {
    if (!A.current || !E.current)
      return;
    const C = {
      placement: t,
      strategy: n,
      middleware: m
    };
    T.current && (C.platform = T.current), Rr(A.current, E.current, C).then((D) => {
      const $ = {
        ...D,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: F.current !== !1
      };
      R.current && !Ce(O.current, $) && (O.current = $, yn.flushSync(() => {
        l($);
      }));
    });
  }, [m, t, n, T, F]);
  ye(() => {
    u === !1 && O.current.isPositioned && (O.current.isPositioned = !1, l((C) => ({
      ...C,
      isPositioned: !1
    })));
  }, [u]);
  const R = w.useRef(!1);
  ye(() => (R.current = !0, () => {
    R.current = !1;
  }), []), ye(() => {
    if (x && (A.current = x), S && (E.current = S), x && S) {
      if (P.current)
        return P.current(x, S, M);
      M();
    }
  }, [x, S, M, P, N]);
  const W = w.useMemo(() => ({
    reference: A,
    floating: E,
    setReference: y,
    setFloating: b
  }), [y, b]), L = w.useMemo(() => ({
    reference: x,
    floating: S
  }), [x, S]), k = w.useMemo(() => {
    const C = {
      position: n,
      left: 0,
      top: 0
    };
    if (!L.floating)
      return C;
    const D = Et(L.floating, d.x), $ = Et(L.floating, d.y);
    return c ? {
      ...C,
      transform: "translate(" + D + "px, " + $ + "px)",
      ...$t(L.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: D,
      top: $
    };
  }, [n, c, L.floating, d.x, d.y]);
  return w.useMemo(() => ({
    ...d,
    update: M,
    refs: W,
    elements: L,
    floatingStyles: k
  }), [d, M, W, L, k]);
}
const Mr = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? At({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? At({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, Lr = (e, t) => ({
  ...br(e),
  options: [e, t]
}), kr = (e, t) => ({
  ...xr(e),
  options: [e, t]
}), Nr = (e, t) => ({
  ...Cr(e),
  options: [e, t]
}), Fr = (e, t) => ({
  ...Sr(e),
  options: [e, t]
}), Dr = (e, t) => ({
  ...Ar(e),
  options: [e, t]
}), Wr = (e, t) => ({
  ...Er(e),
  options: [e, t]
}), Br = (e, t) => ({
  ...Mr(e),
  options: [e, t]
});
var Ir = "Arrow", Vt = w.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ j(
    Re.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ j("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Vt.displayName = Ir;
var _r = Vt;
function Hr(e) {
  const [t, n] = w.useState(void 0);
  return Ve(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, c;
        if ("borderBoxSize" in i) {
          const f = i.borderBoxSize, u = Array.isArray(f) ? f[0] : f;
          s = u.inlineSize, c = u.blockSize;
        } else
          s = e.offsetWidth, c = e.offsetHeight;
        n({ width: s, height: c });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var et = "Popper", [zt, Io] = wn(et), [$r, jt] = zt(et), Xt = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = w.useState(null);
  return /* @__PURE__ */ j($r, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
Xt.displayName = et;
var Yt = "PopperAnchor", Ut = w.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = jt(Yt, n), s = w.useRef(null), c = Ue(t, s), f = w.useRef(null);
    return w.useEffect(() => {
      const u = f.current;
      f.current = (r == null ? void 0 : r.current) || s.current, u !== f.current && i.onAnchorChange(f.current);
    }), r ? null : /* @__PURE__ */ j(Re.div, { ...o, ref: c });
  }
);
Ut.displayName = Yt;
var tt = "PopperContent", [Vr, zr] = zt(tt), Kt = w.forwardRef(
  (e, t) => {
    var nt, rt, ot, it, st, ct;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: s = 0,
      arrowPadding: c = 0,
      avoidCollisions: f = !0,
      collisionBoundary: u = [],
      collisionPadding: d = 0,
      sticky: l = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: v,
      ...a
    } = e, p = jt(tt, n), [g, y] = w.useState(null), b = Ue(t, (ae) => y(ae)), [x, S] = w.useState(null), A = Hr(x), E = (A == null ? void 0 : A.width) ?? 0, O = (A == null ? void 0 : A.height) ?? 0, N = r + (i !== "center" ? "-" + i : ""), P = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, T = Array.isArray(u) ? u : [u], F = T.length > 0, M = {
      padding: P,
      boundary: T.filter(Xr),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: F
    }, { refs: R, floatingStyles: W, placement: L, isPositioned: k, middlewareData: C } = Tr({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: N,
      whileElementsMounted: (...ae) => yr(...ae, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: p.anchor
      },
      middleware: [
        Lr({ mainAxis: o + O, alignmentAxis: s }),
        f && kr({
          mainAxis: !0,
          crossAxis: !1,
          limiter: l === "partial" ? Nr() : void 0,
          ...M
        }),
        f && Fr({ ...M }),
        Dr({
          ...M,
          apply: ({ elements: ae, rects: at, availableWidth: dn, availableHeight: hn }) => {
            const { width: mn, height: pn } = at.reference, he = ae.floating.style;
            he.setProperty("--radix-popper-available-width", `${dn}px`), he.setProperty("--radix-popper-available-height", `${hn}px`), he.setProperty("--radix-popper-anchor-width", `${mn}px`), he.setProperty("--radix-popper-anchor-height", `${pn}px`);
          }
        }),
        x && Br({ element: x, padding: c }),
        Yr({ arrowWidth: E, arrowHeight: O }),
        m && Wr({ strategy: "referenceHidden", ...M })
      ]
    }), [D, $] = Gt(L), de = $e(v);
    Ve(() => {
      k && (de == null || de());
    }, [k, de]);
    const cn = (nt = C.arrow) == null ? void 0 : nt.x, an = (rt = C.arrow) == null ? void 0 : rt.y, ln = ((ot = C.arrow) == null ? void 0 : ot.centerOffset) !== 0, [un, fn] = w.useState();
    return Ve(() => {
      g && fn(window.getComputedStyle(g).zIndex);
    }, [g]), /* @__PURE__ */ j(
      "div",
      {
        ref: R.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...W,
          transform: k ? W.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: un,
          "--radix-popper-transform-origin": [
            (it = C.transformOrigin) == null ? void 0 : it.x,
            (st = C.transformOrigin) == null ? void 0 : st.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((ct = C.hide) == null ? void 0 : ct.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ j(
          Vr,
          {
            scope: n,
            placedSide: D,
            onArrowChange: S,
            arrowX: cn,
            arrowY: an,
            shouldHideArrow: ln,
            children: /* @__PURE__ */ j(
              Re.div,
              {
                "data-side": D,
                "data-align": $,
                ...a,
                ref: b,
                style: {
                  ...a.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: k ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Kt.displayName = tt;
var qt = "PopperArrow", jr = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Zt = w.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = zr(qt, r), s = jr[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ j(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ j(
          _r,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Zt.displayName = qt;
function Xr(e) {
  return e !== null;
}
var Yr = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var p, g, y;
    const { placement: n, rects: r, middlewareData: o } = t, s = ((p = o.arrow) == null ? void 0 : p.centerOffset) !== 0, c = s ? 0 : e.arrowWidth, f = s ? 0 : e.arrowHeight, [u, d] = Gt(n), l = { start: "0%", center: "50%", end: "100%" }[d], m = (((g = o.arrow) == null ? void 0 : g.x) ?? 0) + c / 2, h = (((y = o.arrow) == null ? void 0 : y.y) ?? 0) + f / 2;
    let v = "", a = "";
    return u === "bottom" ? (v = s ? l : `${m}px`, a = `${-f}px`) : u === "top" ? (v = s ? l : `${m}px`, a = `${r.floating.height + f}px`) : u === "right" ? (v = `${-f}px`, a = s ? l : `${h}px`) : u === "left" && (v = `${r.floating.width + f}px`, a = s ? l : `${h}px`), { data: { x: v, y: a } };
  }
});
function Gt(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var _o = Xt, Ho = Ut, $o = Kt, Vo = Zt, Ur = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, ee = /* @__PURE__ */ new WeakMap(), pe = /* @__PURE__ */ new WeakMap(), ge = {}, Be = 0, Qt = function(e) {
  return e && (e.host || Qt(e.parentNode));
}, Kr = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Qt(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, qr = function(e, t, n, r) {
  var o = Kr(t, Array.isArray(e) ? e : [e]);
  ge[n] || (ge[n] = /* @__PURE__ */ new WeakMap());
  var i = ge[n], s = [], c = /* @__PURE__ */ new Set(), f = new Set(o), u = function(l) {
    !l || c.has(l) || (c.add(l), u(l.parentNode));
  };
  o.forEach(u);
  var d = function(l) {
    !l || f.has(l) || Array.prototype.forEach.call(l.children, function(m) {
      if (c.has(m))
        d(m);
      else
        try {
          var h = m.getAttribute(r), v = h !== null && h !== "false", a = (ee.get(m) || 0) + 1, p = (i.get(m) || 0) + 1;
          ee.set(m, a), i.set(m, p), s.push(m), a === 1 && v && pe.set(m, !0), p === 1 && m.setAttribute(n, "true"), v || m.setAttribute(r, "true");
        } catch (g) {
          console.error("aria-hidden: cannot operate on ", m, g);
        }
    });
  };
  return d(t), c.clear(), Be++, function() {
    s.forEach(function(l) {
      var m = ee.get(l) - 1, h = i.get(l) - 1;
      ee.set(l, m), i.set(l, h), m || (pe.has(l) || l.removeAttribute(r), pe.delete(l)), h || l.removeAttribute(n);
    }), Be--, Be || (ee = /* @__PURE__ */ new WeakMap(), ee = /* @__PURE__ */ new WeakMap(), pe = /* @__PURE__ */ new WeakMap(), ge = {});
  };
}, zo = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = Ur(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), qr(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, V = function() {
  return V = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, V.apply(this, arguments);
};
function Jt(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Zr(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var be = "right-scroll-bar-position", xe = "width-before-scroll-bar", Gr = "with-scroll-bars-hidden", Qr = "--removed-body-scroll-bar-size";
function Ie(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Jr(e, t) {
  var n = vn(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var eo = typeof window < "u" ? w.useLayoutEffect : w.useEffect, Ct = /* @__PURE__ */ new WeakMap();
function to(e, t) {
  var n = Jr(null, function(r) {
    return e.forEach(function(o) {
      return Ie(o, r);
    });
  });
  return eo(function() {
    var r = Ct.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), s = n.current;
      o.forEach(function(c) {
        i.has(c) || Ie(c, null);
      }), i.forEach(function(c) {
        o.has(c) || Ie(c, s);
      });
    }
    Ct.set(n, e);
  }, [e]), n;
}
function no(e) {
  return e;
}
function ro(e, t) {
  t === void 0 && (t = no);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, r);
      return n.push(s), function() {
        n = n.filter(function(c) {
          return c !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(c) {
          return i(c);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var s = [];
      if (n.length) {
        var c = n;
        n = [], c.forEach(i), s = n;
      }
      var f = function() {
        var d = s;
        s = [], d.forEach(i);
      }, u = function() {
        return Promise.resolve().then(f);
      };
      u(), n = {
        push: function(d) {
          s.push(d), u();
        },
        filter: function(d) {
          return s = s.filter(d), n;
        }
      };
    }
  };
  return o;
}
function oo(e) {
  e === void 0 && (e = {});
  var t = ro(null);
  return t.options = V({ async: !0, ssr: !1 }, e), t;
}
var en = function(e) {
  var t = e.sideCar, n = Jt(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return w.createElement(r, V({}, n));
};
en.isSideCarExport = !0;
function io(e, t) {
  return e.useMedium(t), en;
}
var tn = oo(), _e = function() {
}, Le = w.forwardRef(function(e, t) {
  var n = w.useRef(null), r = w.useState({
    onScrollCapture: _e,
    onWheelCapture: _e,
    onTouchMoveCapture: _e
  }), o = r[0], i = r[1], s = e.forwardProps, c = e.children, f = e.className, u = e.removeScrollBar, d = e.enabled, l = e.shards, m = e.sideCar, h = e.noRelative, v = e.noIsolation, a = e.inert, p = e.allowPinchZoom, g = e.as, y = g === void 0 ? "div" : g, b = e.gapMode, x = Jt(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), S = m, A = to([n, t]), E = V(V({}, x), o);
  return w.createElement(
    w.Fragment,
    null,
    d && w.createElement(S, { sideCar: tn, removeScrollBar: u, shards: l, noRelative: h, noIsolation: v, inert: a, setCallbacks: i, allowPinchZoom: !!p, lockRef: n, gapMode: b }),
    s ? w.cloneElement(w.Children.only(c), V(V({}, E), { ref: A })) : w.createElement(y, V({}, E, { className: f, ref: A }), c)
  );
});
Le.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Le.classNames = {
  fullWidth: xe,
  zeroRight: be
};
var so = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function co() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = so();
  return t && e.setAttribute("nonce", t), e;
}
function ao(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function lo(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var uo = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = co()) && (ao(t, n), lo(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, fo = function() {
  var e = uo();
  return function(t, n) {
    w.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, nn = function() {
  var e = fo(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, ho = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, He = function(e) {
  return parseInt(e || "", 10) || 0;
}, mo = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [He(n), He(r), He(o)];
}, po = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return ho;
  var t = mo(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, go = nn(), oe = "data-scroll-locked", vo = function(e, t, n, r) {
  var o = e.left, i = e.top, s = e.right, c = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Gr, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(c, "px ").concat(r, `;
  }
  body[`).concat(oe, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(c, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(be, ` {
    right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(xe, ` {
    margin-right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(be, " .").concat(be, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(xe, " .").concat(xe, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(oe, `] {
    `).concat(Qr, ": ").concat(c, `px;
  }
`);
}, Rt = function() {
  var e = parseInt(document.body.getAttribute(oe) || "0", 10);
  return isFinite(e) ? e : 0;
}, wo = function() {
  w.useEffect(function() {
    return document.body.setAttribute(oe, (Rt() + 1).toString()), function() {
      var e = Rt() - 1;
      e <= 0 ? document.body.removeAttribute(oe) : document.body.setAttribute(oe, e.toString());
    };
  }, []);
}, yo = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  wo();
  var i = w.useMemo(function() {
    return po(o);
  }, [o]);
  return w.createElement(go, { styles: vo(i, !t, o, n ? "" : "!important") });
}, Ye = !1;
if (typeof window < "u")
  try {
    var ve = Object.defineProperty({}, "passive", {
      get: function() {
        return Ye = !0, !0;
      }
    });
    window.addEventListener("test", ve, ve), window.removeEventListener("test", ve, ve);
  } catch {
    Ye = !1;
  }
var te = Ye ? { passive: !1 } : !1, bo = function(e) {
  return e.tagName === "TEXTAREA";
}, rn = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !bo(e) && n[t] === "visible")
  );
}, xo = function(e) {
  return rn(e, "overflowY");
}, So = function(e) {
  return rn(e, "overflowX");
}, Ot = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = on(e, r);
    if (o) {
      var i = sn(e, r), s = i[1], c = i[2];
      if (s > c)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Ao = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Eo = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, on = function(e, t) {
  return e === "v" ? xo(t) : So(t);
}, sn = function(e, t) {
  return e === "v" ? Ao(t) : Eo(t);
}, Co = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Ro = function(e, t, n, r, o) {
  var i = Co(e, window.getComputedStyle(t).direction), s = i * r, c = n.target, f = t.contains(c), u = !1, d = s > 0, l = 0, m = 0;
  do {
    if (!c)
      break;
    var h = sn(e, c), v = h[0], a = h[1], p = h[2], g = a - p - i * v;
    (v || g) && on(e, c) && (l += g, m += v);
    var y = c.parentNode;
    c = y && y.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? y.host : y;
  } while (
    // portaled content
    !f && c !== document.body || // self content
    f && (t.contains(c) || t === c)
  );
  return (d && Math.abs(l) < 1 || !d && Math.abs(m) < 1) && (u = !0), u;
}, we = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Pt = function(e) {
  return [e.deltaX, e.deltaY];
}, Tt = function(e) {
  return e && "current" in e ? e.current : e;
}, Oo = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Po = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, To = 0, ne = [];
function Mo(e) {
  var t = w.useRef([]), n = w.useRef([0, 0]), r = w.useRef(), o = w.useState(To++)[0], i = w.useState(nn)[0], s = w.useRef(e);
  w.useEffect(function() {
    s.current = e;
  }, [e]), w.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var a = Zr([e.lockRef.current], (e.shards || []).map(Tt), !0).filter(Boolean);
      return a.forEach(function(p) {
        return p.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), a.forEach(function(p) {
          return p.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = w.useCallback(function(a, p) {
    if ("touches" in a && a.touches.length === 2 || a.type === "wheel" && a.ctrlKey)
      return !s.current.allowPinchZoom;
    var g = we(a), y = n.current, b = "deltaX" in a ? a.deltaX : y[0] - g[0], x = "deltaY" in a ? a.deltaY : y[1] - g[1], S, A = a.target, E = Math.abs(b) > Math.abs(x) ? "h" : "v";
    if ("touches" in a && E === "h" && A.type === "range")
      return !1;
    var O = window.getSelection(), N = O && O.anchorNode, P = N ? N === A || N.contains(A) : !1;
    if (P)
      return !1;
    var T = Ot(E, A);
    if (!T)
      return !0;
    if (T ? S = E : (S = E === "v" ? "h" : "v", T = Ot(E, A)), !T)
      return !1;
    if (!r.current && "changedTouches" in a && (b || x) && (r.current = S), !S)
      return !0;
    var F = r.current || S;
    return Ro(F, p, a, F === "h" ? b : x);
  }, []), f = w.useCallback(function(a) {
    var p = a;
    if (!(!ne.length || ne[ne.length - 1] !== i)) {
      var g = "deltaY" in p ? Pt(p) : we(p), y = t.current.filter(function(S) {
        return S.name === p.type && (S.target === p.target || p.target === S.shadowParent) && Oo(S.delta, g);
      })[0];
      if (y && y.should) {
        p.cancelable && p.preventDefault();
        return;
      }
      if (!y) {
        var b = (s.current.shards || []).map(Tt).filter(Boolean).filter(function(S) {
          return S.contains(p.target);
        }), x = b.length > 0 ? c(p, b[0]) : !s.current.noIsolation;
        x && p.cancelable && p.preventDefault();
      }
    }
  }, []), u = w.useCallback(function(a, p, g, y) {
    var b = { name: a, delta: p, target: g, should: y, shadowParent: Lo(g) };
    t.current.push(b), setTimeout(function() {
      t.current = t.current.filter(function(x) {
        return x !== b;
      });
    }, 1);
  }, []), d = w.useCallback(function(a) {
    n.current = we(a), r.current = void 0;
  }, []), l = w.useCallback(function(a) {
    u(a.type, Pt(a), a.target, c(a, e.lockRef.current));
  }, []), m = w.useCallback(function(a) {
    u(a.type, we(a), a.target, c(a, e.lockRef.current));
  }, []);
  w.useEffect(function() {
    return ne.push(i), e.setCallbacks({
      onScrollCapture: l,
      onWheelCapture: l,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", f, te), document.addEventListener("touchmove", f, te), document.addEventListener("touchstart", d, te), function() {
      ne = ne.filter(function(a) {
        return a !== i;
      }), document.removeEventListener("wheel", f, te), document.removeEventListener("touchmove", f, te), document.removeEventListener("touchstart", d, te);
    };
  }, []);
  var h = e.removeScrollBar, v = e.inert;
  return w.createElement(
    w.Fragment,
    null,
    v ? w.createElement(i, { styles: Po(o) }) : null,
    h ? w.createElement(yo, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function Lo(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const ko = io(tn, Mo);
var No = w.forwardRef(function(e, t) {
  return w.createElement(Le, V({}, e, { ref: t, sideCar: ko }));
});
No.classNames = Le.classNames;
export {
  Ho as A,
  $o as C,
  xn as F,
  No as R,
  _o as a,
  Vo as b,
  Io as c,
  zo as h,
  Bo as u
};
